import { Locale } from "../../../utils";

const i18n = Locale.getInstance();
export default [
  {
    href: "/main/lottery/recommender",
    title: i18n.t("recommender.title"),
  },
];
